import React,{useState} from "react";
import ListComponent from "../components/ListComponent";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

const List = ({ setList, sip, makeCall }) => {
  const [apikey, setApikey] = useState(window.config?.accountId);
  const [, setData] = useState("No Data");

  const handleConfChange = (e) => {
    setApikey(e.target.value);
  };

  function ClearResponse() {
    setData("");
  }
  function makeCallAPI(event) {
    ClearResponse();
    const requestBody = window.config?.call?.requestBody;
    const [api, apiOptions] = makeCallApiInstance(true);
    api
      .makeCall(apikey, requestBody, apiOptions)
      .then((response) => {
        setData(JSON.stringify(response));
        toast.success("Api call success");
      })
      .catch((error) => {
        console.log("error", error);
        toast.error("Failed, StatusCode:" + error?.response?.data?.message);
      });
    setList(false);
  }
  return (
    <div>
      <ListComponent
        handleClick={makeCallAPI}
        handleChange={handleConfChange}
        sip={sip}
        // data={apikey}
        heading="Room List"
        setList={setList}
        makeCall={makeCall}
      />
    </div>
  );
};
List.propTypes = {
  setList: PropTypes.any,
  sip: PropTypes.any,
  makeCall: PropTypes.any,
};
export default List;
